<template>
  <footer032 />
</template>

<script>
import footer032 from '@/pages/footer/p_footer032.vue';

export default {
  components: {
    footer032
  }
};
</script>
